<template>
  <div class="CustomerService">
    <BannerVideo :video-url="$StaticFileUrl + '/mp/video/customer-service-video_2.mp4'">
      <div class="title wow fadeInDown" data-wow-duration="1s">AI智能客服解决方案</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">链接客户，洞察人心，为企业在线营销赋能</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即体验</div>
      </div>
    </BannerVideo>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
export default {
  name: 'CustomerService',
  components: {BannerVideo},
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
